import {
  EntityDropdownInputBare,
  type EntityDropdownInputBareProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInputBare";
import useLocalization from "#src/hooks/useLocalization";
import { EquipmentAdapter } from "@validereinc/domain";
import React from "react";

/**
 * Uncontrolled Equipment dropdown using DropdownInputBare for use in FilterBuilder.
 * Value is controlled by parent (e.g. filter state); does not register with react-hook-form.
 */
export const EquipmentDropdownInputBare = (
  props: Omit<EntityDropdownInputBareProps<unknown>, "fetchEntityList">
) => {
  const { localize } = useLocalization();

  return (
    <EntityDropdownInputBare
      fetchEntityList={EquipmentAdapter.getList}
      label={props.label ?? localize("Equipment")}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
